import { render, staticRenderFns } from "./ExtTab.vue?vue&type=template&id=aa8ec846"
import script from "./ExtTab.vue?vue&type=script&lang=js"
export * from "./ExtTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports